import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MasterComponent } from './master.component';


@NgModule({
  declarations: [
    MasterComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class MasterModule { }
